import script from "./WechatBindingReminder.vue?vue&type=script&setup=true&lang=ts"
export * from "./WechatBindingReminder.vue?vue&type=script&setup=true&lang=ts"

import "./WechatBindingReminder.vue?vue&type=style&index=0&id=20150b4c&scoped=true&lang=css"

import exportComponent from "../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20150b4c"]])

export default __exports__